import DesktopMacIcon from '@material-ui/icons/DesktopMac';
import ServiceRequestList from './ServiceRequestList';

const ServiceRequest = {
  list: ServiceRequestList,
  icon: DesktopMacIcon
};
export default ServiceRequest;
